<template>
  <div class="employeeslist">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Operational Line Managers</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Managers</li>
                </ul>
              </div>
              
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  v-model="filterEmpId"
                  @keyup="employeeCode"
                  type="text"
                  class="form-control floating"
                  style="height: 55px !important;"
                />
                <label class="focus-label">Employee ID</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  v-model="filterEmpName"
                  @keyup="looksearch"
                  class="form-control floating"
                  style="height: 55px !important;"
                />
                <label class="focus-label">Employee Name</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="form-group form-focus select-focus">
                <multiselectvue
                  class="from-control"
                  v-model="newEmployeeDesignation"
                  placeholder="Select Designation"
                  :custom-label="nameOfDesignation"
                  :options="sortedEmployeeDesignation"
                  :searchable="true"
                  @select="optionSelectDesignation"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{
                    option.name
                  }}</template>
                </multiselectvue>
                <!-- <select
                  class="form-control"
                  style="height: 55px !important;"
                  v-model="filterDesignationId"
                >
                  <option>Select Designation</option>
                  <option
                    v-for="item in sortedEmployeeDesignation"
                    :key="item.id"
                    :value="parseInt(item.id)"
                    >{{ item.name }}</option
                  >
                </select>
                <label class="focus-label">Designation</label> -->
              </div>
            </div>
            <div class="col-sm-6 col-md-2" style="height: 60px !important;">
              <div class="form-group form-focus select-focus">
                <!-- <select
                  class="form-control"
                  style="height: 55px !important;"
                  v-model="filterDepartmentId"
                  @change="searchDepart"
                >
                  <option>Select Department</option>
                  <option
                    v-for="item in departments"
                    :key="item.id"
                    :value="parseInt(item.id)"
                    >{{ item.name }}</option
                  >
                </select> -->

                <multiselectvue
                  class="from-control"
                  v-model="selectDeparment"
                  placeholder="Select Department"
                  :custom-label="nameOfRank"
                  :options="sortedDepartment"
                  :searchable="true"
                  @select="optionSelectRank"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }">{{
                    option.name
                  }}</template>
                </multiselectvue>
                <!-- <label class="focus-label">Department</label> -->
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <a href="#" @click="getFilter" class="btn btn-success btn-block">
                Search
              </a>
            </div>
          </div>
          <!-- /Search Filter -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="searchEmployeeList"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar">
                      <div class="avatar">
                        <img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.passportPhoto"
                        />
                        <img
                          alt=""
                          :src="media + item.passportPhoto"
                          width="38"
                          v-if="item.passportPhoto"
                        />
                      </div>
                      <div v-if="item.status == 3">
                        <p>{{ item.firstName + " " + item.lastName }}</p>
                        <span>{{ item.designation.name }}</span>
                      </div>
                      <div v-else>
                        {{ item.firstName + " " + item.lastName }}
                        <span>{{ item.designation.name }}</span>
                      </div>
                    </h2>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <router-link :to="{name: 'optmanager', params: {id: item.id}}" class="btn btn-primary">Detail</router-link>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      company: authenticationService.currentOfficeValue,
      employees: [],
      nofilterEmployees: [],
      designations: [],
      media: "data:image/jpeg;base64,",
      ranks: null,
      departments: [],
      submitted: false,
      loading: false,
      selectDeparment: "",
      newEmployeeDesignation: "",
      error: "",
      message: "",
      filterDesignationId: "",
      filterEmpName: "",
      filterEmpId: "",
      filterDepartmentId: "",
      newData: [],

      headers: [
        {
          text: "Name",
          align: "start",
          value: "profile",
          sortable: false
        },

        { text: "Employee Code", value: "employeeCode" },
        { text: "Email", value: "email" },
        { text: "Mobile", value: "phone" },
        { text: "Action", value: "actions", sortable: false }
      ]
    };
  },
  validations: {
    firstName: { required },
    lastName: { required },
    rankId: { required },
    //address: { required },
    phone: { required },
    email: { required },
    designationId: { required }
  },

  computed: {
    searchEmployeeList: function() {
      return this.employees.filter(
        d =>
          d.firstName
            .toLowerCase()
            .includes(this.filterEmpName.toLowerCase()) ||
          d.lastName.toLowerCase().includes(this.filterEmpName.toLowerCase())
      );
    },

    searchEmployeeList: function() {
      function compare(a, b) {
        if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) return -1;
        if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) return 1;
        return 0;
      }

      return this.newData.sort(compare);
    },

    sortedEmployeeDesignation: function() {
      function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }

      return this.designations
        ? this.designations.sort(compare)
        : this.designations;
    },
    sortedDepartment: function() {
      function compare(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }

      return this.departments
        ? this.departments.sort(compare)
        : this.departments;
    }
  },

  methods: {
    // searchDepart() {
    //   this.employees = this.nofilterEmployees.filter(c => {
    //     console.log(this.filterDepartmentId);
    //     if (this.filterDepartmentId == c.designation.departmentId) {
    //       console.log("seen");
    //       this.filterDepartmentId == c.designation.departmentId;
    //       c.designation.departmentId == parseInt(this.filterDepartmentId);
    //     }
    //   });
    // },

    nameOfDesignation({ name }) {
      return `${name}`;
    },

    optionSelectDesignation(option, id) {
      console.log(option.id, this.newEmployeeDesignation.id);
      this.filterDesignationId = option.id;
    },

    nameOfRank({ name }) {
      return `${name}`;
    },

    optionSelectRank(option, id) {
      console.log(option.id, this.selectDeparment.id);
      this.filterDepartmentId = option.id;
    },
    getFilter() {
      // console.log(this.employees.designation.departmentId);
      this.employees = this.nofilterEmployees;
      var employee = [];
      if (this.filterEmpId != "") {
        this.newData = this.nofilterEmployees.filter(
          c =>
            c.employeeCode != null &&
            c.employeeCode.toLowerCase().match(this.filterEmpId.toLowerCase())
        );
      }
      if (this.filterEmpName != "" && this.filterDesignationId != "") {
        this.newData = this.nofilterEmployees.filter(
          c =>
            this.filterEmpName.toLowerCase().match(c.firstName.toLowerCase()) ||
            this.filterEmpName.toLowerCase().match(c.lastName.toLowerCase()) ||
            c.designationId == parseInt(this.filterDesignationId)
        );
      }
      if (this.filterEmpName != "" && this.filterDepartmentId != "") {
        this.newData = this.nofilterEmployees.filter(
          c =>
            this.filterEmpName.toLowerCase().match(c.firstName.toLowerCase()) ||
            this.filterEmpName.toLowerCase().match(c.lastName.toLowerCase()) ||
            c.designation.departmentId == parseInt(this.filterDepartmentId)
        );
      }

      if (this.filterEmpName != "" && this.filterDesignationId == "") {
        this.newData = this.nofilterEmployees.filter(c =>
          c.fullName.toLowerCase().includes(this.filterEmpName.toLowerCase())
        );
      }
      if (this.filterDesignationId != "") {
        this.newData = this.nofilterEmployees.filter(
          c => c.designationId == parseInt(this.filterDesignationId)
        );
      }
      if (this.filterDepartmentId != "") {
        this.newData = this.nofilterEmployees.filter(c => {
          if (c.designation.departmentId == this.filterDepartmentId) {
            c.designation.departmentId == parseInt(this.filterDepartmentId);
            console.log("found");
          }
          // console.log(c.designation);
        });
        console.log("click");
      }
      if (
        this.filterEmpId == "" &&
        this.filterEmpName == "" &&
        this.filterDesignationId == "" &&
        this.filterDepartmentId
      ) {
        this.newData = this.nofilterEmployees;
      }
    },

    looksearch() {
      this.newData = this.nofilterEmployees.filter(c =>
        c.fullName.toLowerCase().includes(this.filterEmpName.toLowerCase())
      );
    },
    employeeCode() {
      this.newData = this.nofilterEmployees.filter(
        c =>
          c.employeeCode != null &&
          c.employeeCode.toLowerCase().match(this.filterEmpId.toLowerCase())
      );
    },
    GetDesignations() {
      organizationService.getDesignations().then(
        model => {
          this.designations = model;
          console.log(this.designations);
        },
        error => {
          this.error = error;
        }
      );
    },
    GetRanks() {
      organizationService.getRanks().then(
        model => {
          this.ranks = model;
        },
        error => {
          this.error = error;
        }
      );
    },

    GetDepartments() {
      organizationService.getDepartments().then(
        model => {
          this.departments = model;
          console.log(this.departments);
        },
        error => {
          error = error;
        }
      );
    },
    GetEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getOperationalManagers(unit.id).then(
        model => {
          (this.employees = model), (this.nofilterEmployees = model);
          console.log(model, unit.id);

          this.newData = model.map(c => {
            return { ...c, fullName: c.firstName + " " + c.lastName };
          });
          this.nofilterEmployees = model.map(c => {
            return { ...c, fullName: c.firstName + " " + c.lastName };
          });

          console.log(this.newData);
        },

        error => {
          this.error = error;
        }
      );
    }
  },
  mounted() {
    this.GetRanks();
    this.GetDesignations();
    this.GetEmployees();
    this.GetDepartments();
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "employeeslist"
};
</script>



// WEBPACK FOOTER //
// src/components/employees/operationalManagers.vue